import baseApi from "../api/baseApi";

const userApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getSingleStudent: builder.query({
      query: () => ({
        url: "/user/getSingleStudent",
        method: "GET",
      }),
      providesTags: ["User"],
    }),
    updateStudentInformation: builder.mutation({
      query: (body) => ({
        url: "/user/updateStudentInformation",
        method: "PATCH",
        body,
      }),
    }),
    changePassword: builder.mutation({
      query: (body) => ({
        url: "/user/changePassword",
        method: "PATCH",
        body,
      }),
    }),
  }),
});

export const {
  useGetSingleStudentQuery,
  useUpdateStudentInformationMutation,
  useChangePasswordMutation,
} = userApi;

export default userApi;
